<template>
  <div class="max-height-container scroll-y">

    <div v-if='isMember'>
      <h6 class="pt-3 pr-3 pl-3 text-primary" @click='showAddUsers = !showAddUsers'>
       Add Users
       <img class="float-right" style="height:25px; width:25px;" src="static/assets/img/icon-add-members-blue.png" />
       </h6>
      <b-collapse v-model='showAddUsers' id='addUsers'>
        <div>
          <div class="p-3">
            <input class="form-control" placeholder="Search by Name or Email" v-model='searchText' />
          </div>
          <ul class="list-group list-group-flush" v-if='possibleUsers && searchText.length > 3' >
            <li v-for='result in possibleUsers' :key='result.Id' class="list-group-item">
              <table class="w-100">
                <tr>
                  <td width="40px" @click='addUser(group.GroupId, result.Id)'><img v-if='result.AvatarUrl' :src='result.AvatarUrl' height='40px' width='40px;'/><img v-else src='static/assets/img/avatar.png' height='40px' width='40px;'/></td>
                  <td class="px-3">
                    <table>
                      <tr>
                        <td @click='addUser(group.GroupId, result.Id)'> <b class="text-primary">{{result.Name}}</b></td>
                      </tr>
                      <tr>
                        <td>{{result.Platform}}</td>
                      </tr>
                    </table>
                  </td>
                  <td @click='addUser(group.GroupId, result.Id)'><img src="static/assets/img/icon-add-user-plus.png" />  </td>
                </tr>
              </table>
            </li>
          </ul>
        </div>
      </b-collapse>

      <div class="px-3 py-2">
        <h6>Conversation Members</h6>
      </div>
      <ul class="list-group list-group-flush">
        <li v-for='user in sortedUsers' :key='user.Id' class="list-group-item">
          <table>
            <tr>
              <td>
                <img :src='user.AvatarUrl' height='40px' width='40px' v-if='user.AvatarUrl'/>
                <img v-else src='static/assets/img/avatar.png' height='40px' width='40px' /> 
              </td>
              <td class="px-3">
                <table>
                  <tr>
                    <td><b class="text-primary">{{user.Name}}</b></td>
                  </tr>
                  <tr>
                    <td>{{user.Platform}}</td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </li>
      </ul>

    </div>
  </div>

</template>

<script>
  import {
    MessengerAPIClient
  } from '@/lib/data_access/messenger'
  import {alphabeticSortOnKey} from '@/lib/utilities/index'
  export default {
    name: 'usersList',
    props: ['group', 'user', 'isMember'],
    data() {
      return {
        searchText: '',
        possibleUsers: [],
        showAddUsers: true
      }
    },
    computed: {
      sortedUsers: function (){
        let vm = this;
        console.log(vm.group.Users)
        if(vm.group.Users){
          return alphabeticSortOnKey(vm.group.Users, "LastName")
        }
        else return []
      }
    },
    watch: {
      searchText: {
        handler: function (newVal, oldVal) {
          let vm = this;
          if (newVal.length >= 3) {
              if(newVal.length < 20){
                vm.searchUsers(newVal)
              }
          }
          else
          {
              vm.possibleUsers = [];
          }
        }
      },
      showAddUsers: function (newVal, oldVal){
          let vm = this;
          vm.possibleUsers = [];
          vm.searchText = '';
      }
    },
    methods: {
      noAvatar: function (event){
        console.log(event)
      },
      searchUsers: function (searchText) {
        console.log(this.user)
        let vm = this;
        let searchObj = {}
        searchObj.from = 0
        searchObj.size = 10
        searchObj.accountPlatformIds = [vm.user.AccountPlatformID]
        searchObj.orderBy = 'lastname'
        searchObj.orderDir = 'asc'
        searchObj.search = searchText
        console.log(searchText)
        MessengerAPIClient.searchUsers(searchObj).then(function (resp) {
          vm.possibleUsers = resp.results
        })
      },
      addUser:function (groupId,userId){
        let vm = this;
        console.log(groupId, userId)
        MessengerAPIClient.addUserToGroup(groupId, userId).then(function(resp){
          vm.searchText = '';
        })
      }
    }
  }

</script>

<style lang="scss" scoped>
  .max-height-container {
      min-height:60px;
      max-height: calc(100vh - 292px - 60px);
      // position: relative;
      width: auto;
      // overflow-y:auto;
      // padding-bottom: 100px;

    }

</style>



// WEBPACK FOOTER //
// src/components/Messenger/UsersList/UsersList.vue